import "./index.css"
import React, { Suspense, lazy } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import store from "./store/store"
import AppLoader from "./components/hoc/appLoader"
import CompanyBootstrap from "./components/hoc/CompanyBootstrap"
import ClientSalonGate from "./components/routing/ClientSalonGate"
import ClientProtectedRoute from "./components/routing/ClientProtectedRoute"
import CrmProtectedRoute from "./components/routing/CrmProtectedRoute"
import CrmChatsRoute from "./components/routing/CrmChatsRoute"
import PageLoadingShell from "./components/ui/pageLoadingShell"
import { Provider } from "react-redux"

import NavBar from "./components/ui/navBar"
import UserLoginPage from "./pages/userLoginPage"
import UserRegisterPage from "./pages/userRegisterPage"
import ClientLoginPage from "./pages/clientLoginPage"
import ClientMainPage from "./pages/clientMainPage"
import FeedbackPage from "./pages/feedbackPage"
import MastersPage from "./pages/mastersPage"
import StartPage from "./pages/startPage"
import CrmPasswordRecoveryPage from "./pages/crmPasswordRecoveryPage"
import NotFoundPage from "./pages/notFoundPage"

const ClientProfilePage = lazy(() => import("./pages/clientProfilePage"))
const CrmMainPage = lazy(() => import("./pages/crmMainPage"))
const ClientsPage = lazy(() => import("./pages/clientsPage"))
const ClientPage = lazy(() => import("./pages/clientPage"))
const MasterPage = lazy(() => import("./pages/masterPage"))
const CrmProfilePage = lazy(() => import("./pages/crmProfilePage"))
const ClientCalendarPage = lazy(() => import("./pages/clientCalendarPage"))
const CrmCalendarPage = lazy(() => import("./pages/crmCalendarPage"))
const CrmChatsPage = lazy(() => import("./pages/crmChatsPage"))
const AdminRouter = lazy(() => import("./pages/admin/AdminRouter"))

const PageFallback = () => <PageLoadingShell />

function App() {
  return (
    <>
      <Provider store={store}>
        <AppLoader>
          <BrowserRouter>
            <CompanyBootstrap>
              <div className="min-h-screen bg-cream">
                <NavBar />

                <Suspense fallback={<PageFallback />}>
                  <Routes>
                    <Route path="/" element={<StartPage />} />

                    <Route path="/crm/login" element={<UserLoginPage />} />
                    <Route path="/crm/register" element={<UserRegisterPage />} />
                    <Route
                      path="/crm/password-recovery"
                      element={<CrmPasswordRecoveryPage />}
                    />

                    <Route
                      path="/client/login"
                      element={
                        <ClientSalonGate>
                          <ClientLoginPage />
                        </ClientSalonGate>
                      }
                    />
                    <Route
                      path="/client/record"
                      element={
                        <ClientProtectedRoute>
                          <ClientCalendarPage />
                        </ClientProtectedRoute>
                      }
                    />
                    <Route
                      path="/crm/chats"
                      element={
                        <CrmProtectedRoute>
                          <CrmChatsRoute>
                            <CrmChatsPage />
                          </CrmChatsRoute>
                        </CrmProtectedRoute>
                      }
                    />
                    <Route
                      path="/crm/calendar"
                      element={
                        <CrmProtectedRoute>
                          <CrmCalendarPage />
                        </CrmProtectedRoute>
                      }
                    />
                    <Route
                      path="/client/feedback"
                      element={
                        <ClientProtectedRoute>
                          <FeedbackPage />
                        </ClientProtectedRoute>
                      }
                    />
                    <Route
                      path="/crm/feedbacks"
                      element={
                        <CrmProtectedRoute>
                          <ClientsPage />
                        </CrmProtectedRoute>
                      }
                    />
                    <Route
                      path="/client/masters"
                      element={
                        <ClientProtectedRoute>
                          <MastersPage />
                        </ClientProtectedRoute>
                      }
                    />
                    <Route
                      path="/crm/profile"
                      element={
                        <CrmProtectedRoute>
                          <CrmProfilePage />
                        </CrmProtectedRoute>
                      }
                    />
                    <Route
                      path="/client/profile"
                      element={
                        <ClientProtectedRoute>
                          <ClientProfilePage />
                        </ClientProtectedRoute>
                      }
                    />
                    <Route
                      path="/client/master/:userId"
                      element={
                        <ClientProtectedRoute>
                          <MasterPage />
                        </ClientProtectedRoute>
                      }
                    />
                    <Route
                      path="/crm/client/:clientId"
                      element={
                        <CrmProtectedRoute>
                          <ClientPage />
                        </CrmProtectedRoute>
                      }
                    />
                    <Route
                      path="/crm"
                      element={
                        <CrmProtectedRoute>
                          <CrmMainPage />
                        </CrmProtectedRoute>
                      }
                    />
                    <Route
                      path="/client"
                      element={
                        <ClientProtectedRoute>
                          <ClientMainPage />
                        </ClientProtectedRoute>
                      }
                    />
                    <Route path="/admin/*" element={<AdminRouter />} />
                    <Route path="*" element={<NotFoundPage />} />
                  </Routes>
                </Suspense>
              </div>
            </CompanyBootstrap>
          </BrowserRouter>
        </AppLoader>
      </Provider>
    </>
  )
}

export default App
